const LS_KEY = 'spcx_recent'
const MAX_ITEMS = 8

interface RecentVisit {
  url: string
  visitedAt: number
}

export function recordVisit(url: string): void {
  try {
    const existing = getRecentVisits().filter((v) => v.url !== url)
    const updated: RecentVisit[] = [{ url, visitedAt: Date.now() }, ...existing].slice(0, MAX_ITEMS)
    localStorage.setItem(LS_KEY, JSON.stringify(updated))
  } catch {}
}

export function getRecentVisits(): RecentVisit[] {
  try {
    const raw = localStorage.getItem(LS_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed as RecentVisit[]
  } catch {
    return []
  }
}
